import colors from 'distinct-colors';
import * as L from 'leaflet';
import React from 'react';
import * as ReactDOM from 'react-dom';
import 'leaflet-routing-machine';
import NetherlandsBoundedMap from '../../components/Map/NetherlandsBoundedMap';
import './../../addons/svg-marker';

// todo: check for future package update, this is a bug from leaflet
//  version: 1.3.4
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

interface Props {
  routes: any[];
  height: number;
  width: number;
}

interface State {
  width: number;
  selection: any[];
  date: string;
  routes: any[];
}

class RouteMap extends React.Component<Props, State> {
  private readonly mapRef: any;
  assetLayerGroup: [];

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      width: this.props.width,
      selection: [],
      date: this.props.routes[0].date_driven,
      routes: []
    };
    this.assetLayerGroup = [];
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentDidUpdate() {
    if (this.assetLayerGroup && this.mapRef.current) {
      let layers = this.mapRef.current.leafletElement._layers;
      for (let index in layers) {
        if (layers.hasOwnProperty(index)) {
          let layer = layers[index];
          if (layer._waypoints || layer._route || layer._latlngs) {
            this.mapRef.current.leafletElement.removeLayer(layer);
          }
        }
      }
    }
    this.assetLayerGroup = this.initMapControl();
  }

  componentDidMount() {
    this.assetLayerGroup = this.initMapControl();
    const width = this.getMapWidth();
    if (width !== undefined) {
      this.setState({ width });
    }
  }

  getColorString(palette, index) {
    let color = palette[index]._rgb;
    return `rgb(${color[0]},${color[1]},${color[2]})`;
  }

  onDateChange(date, dateString) {
    this.setState({ date: dateString });
  }

  getMarker(waypoint, index, palette, order) {
    let customer = order.customer;
    const color = this.getColorString(palette, index);

    const iconOptions: Record<string, any> = {
      fillColor: color,
      color: 'black',
      iconSize: [22, 34],
      weight: 1
    };
    if (this.props.routes.length <= 1) {
      iconOptions.iconSize = [32, 44];
      iconOptions.circleRatio = 0.7;
      iconOptions.fontSize = 14;
      iconOptions.circleText = (order.route_order + 1).toString();
    }

    const content =
      order.type !== 'depot'
        ? `<p>
        <strong>Adres:</strong><br>
        <span>${
          customer.first_name +
          ' ' +
          (customer.infix ? customer.infix + ' ' + customer.last_name : customer.last_name)
        }</span></br>
        <span>${order.street_name + ' ' + order.door_number}</span></br>
        <span>${order.postal_code + ' ' + order.city}</span></br>
        </p>`
        : `<p>
        <strong>Adres:</strong><br>
        <span>Depot ${order.depot.name}</span></br>
        <span>${order.street_name} ${order.door_number}</span></br>
        <span>${order.postal_code} ${order.city}</span></br>
        </p>`;

    return L.marker
      .svgMarker(waypoint.latLng, {
        order: order,
        iconOptions: iconOptions
      })
      .bindPopup(content);
  }

  private initMapControl() {
    let number_of_colors = this.props.routes.length > 1 ? this.props.routes.length : 3;
    let palette = colors({ count: number_of_colors, lightMin: 10, hueMin: 10, chromaMin: 70 });

    let controls: any = [];
    let routes = this.props.routes;

    for (let _index in routes) {
      if (routes.hasOwnProperty(_index)) {
        let route = routes[_index];
        const waypoints = route.orders.sort((a, b) => a.route_order - b.route_order);
        const mappedWaypoints = waypoints.map((position) => L.latLng(position.lat, position.lng));

        // @ts-ignore
        const routing = L.Routing;

        let mapControl = routing
          .control({
            waypointMode: 'snap',
            router: new routing.OSRMv1({
              serviceUrl: process.env.REACT_APP_LOGISTICS_LEAFLET_URL
            }),
            lineOptions: {
              styles: [
                { color: 'black', opacity: 1, weight: 4 },
                { color: this.getColorString(palette, _index), opacity: 1, weight: 2 }
              ]
            },
            plan: new routing.Plan(mappedWaypoints, {
              createMarker: (index, waypoint) =>
                this.getMarker(waypoint, _index, palette, waypoints[index]),
              geocoderClass: () => this.getColorString(palette, _index)
            })
          })
          .addTo(this.mapRef.current.leafletElement)
          .getPlan();
        controls.push(mapControl);
      }
    }

    return controls;
  }

  private getMapWidth(): number | undefined {
    const domNode = ReactDOM.findDOMNode(this.mapRef.current);
    if (domNode !== null && domNode instanceof Element) {
      const parent = domNode.parentNode;
      if (parent !== null && parent instanceof Element) {
        return parent.clientWidth;
      }
    }
    return undefined;
  }

  render = () => {
    const [firstRoute] = this.props.routes;

    let zoomLevel = 8; // Laat hele NL kaart zien op deze hoogte. Indien er default geen route is, overzicht van heel NL
    let centerNL: [number, number] = [52.160508, 5.367966]; // Default midden NL
    if (firstRoute && firstRoute.orders && firstRoute.orders.length > 0) {
      const orders = firstRoute.orders ?? [];
      if (orders.length > 0) {
        centerNL = [orders[0].lat, orders[0].lng];
        zoomLevel = 13;
      }
    }

    return (
      <div>
        <NetherlandsBoundedMap
          center={centerNL}
          zoom={zoomLevel}
          style={{ height: this.props.height, width: '100%' }}
          mapRef={this.mapRef}
        />
      </div>
    );
  };
}

export default RouteMap;
